import * as React from 'react';
import FieldBase from './FieldBase';
import { IFieldBaseProperties, IFieldValueProperties, ISelectFieldItem, IFieldEvent, IValidationProperties } from './interfaces';
import FieldTypes from './enums/FieldTypes';
import classNames from 'classnames';

interface ISelectFieldProperties extends IFieldBaseProperties, IFieldValueProperties, IValidationProperties {  
  placeholder?: string;
  items: ISelectFieldItem[];
}

export class SelectField extends React.PureComponent<ISelectFieldProperties> {
  constructor(props: ISelectFieldProperties) {
    super(props);
    
    this.onChange = this.onChange.bind(this);
  }
  
  onChange(event: React.FormEvent<HTMLSelectElement>) {
    event.preventDefault();

    if (this.props.onChange !== undefined)
    {
      this.props.onChange({
        id: event.currentTarget.id,
        name: event.currentTarget.name,
        value: event.currentTarget.value
      });
    }
  }

  render() {
    let inputClasses = classNames({
      "hcs-select_custom__input": true,
      "w-full": true,
      "input-validation-error": this.props.valid === false
    });
    
    let options = this.props.items.map((item: ISelectFieldItem) => {
      return <option key={this.props.id + `_options_${item.value}`} value={item.value}>{item.label}</option>;
    }, this);

    return <FieldBase key={this.props.id + "_field"} {...this.props} type={FieldTypes.SELECT_CUSTOM}>
      <select key={this.props.id + "_text"}
        className={inputClasses}
        id={this.props.id}
        name={this.props.id}
        value={this.props.value || ''}
        onChange={this.onChange}
        required>
          { this.props.placeholder != undefined && (<option key={this.props.id + "_default"} value="">{this.props.placeholder}</option>)}
          {options}
      </select>
    </FieldBase>;
  }
}

export default SelectField;